import { z } from "zod";

export const ttConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number().nullable(),
    readNum: z.number(),
    incomeNum: z.number(),
    incomeNumYesterday: z.number().nullable(),
    showNumYesterday: z.number().nullable(),
    readNumYesterday: z.number().nullable(),
    likeNumYesterday: z.number().nullable(),
    commentNumYesterday: z.number().nullable(),
});

export type ttConfigData = z.infer<typeof ttConfigDataSchema>;

export const xhsConfigDataSchema = z.object({
    fansNum: z.number(),
    favedNum: z.number(),
    watchNumLastWeek: z.number(),
    likeNumLastWeek: z.number(),
    collectNumLastWeek: z.number(),
    commentNumLastWeek: z.number(),
    fansNumLastWeek: z.number(),
    fansNumYesterday: z.number(),
});

export type xhsConfigData = z.infer<typeof xhsConfigDataSchema>;

export const wxConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number(),
    readNumYesterday: z.number(),
    shareNumYesterday: z.number(),
});

export type wxConfigData = z.infer<typeof wxConfigDataSchema>;

export const bjhConfigDataSchema = z.object({
    fansNum: z.number(),
    fansNumYesterday: z.number().nullable(),
    readNum: z.number(),
    incomeNum: z.number(),
    incomeNumYesterday: z.number().nullable(),
    recommendNumYesterday: z.number().nullable(),
    readNumYesterday: z.number().nullable(),
    likeNumYesterday: z.number().nullable(),
    commentNumYesterday: z.number().nullable(),
});

export type bjhConfigData = z.infer<typeof bjhConfigDataSchema>;

// 抖音账号数据（参考文档 1.1 近7日数据 + 1.2 账号基础信息）
export const douyinConfigDataSchema = z.object({
    fansNum: z.number(), // 粉丝总数（account_info.follower_count）
    favedNum: z.number(), // 总获赞数（account_info.total_favorited）
    fansNumLastWeek: z.number(), // 近7日净增粉丝（data.fans_incr）
    watchNumLastWeek: z.number(), // 近7日播放量（data.play_count）
    likeNumLastWeek: z.number(), // 近7日作品点赞（data.like_count）
    commentNumLastWeek: z.number(), // 近7日作品评论（data.comment_count）
    shareNumLastWeek: z.number(), // 近7日作品分享（data.share_count）
    visitNumLastWeek: z.number(), // 近7日主页访问量（data.profile_visit）
});

export type douyinConfigData = z.infer<typeof douyinConfigDataSchema>;

// 视频号账号数据（auth_data 接口，实测响应结构）
export const shipinhaoConfigDataSchema = z.object({
    fansNum: z.number(), // 粉丝数（data.finderUser.fansCount）
    feedsCount: z.number(), // 作品总数（data.finderUser.feedsCount，不区分视频/图文）
    // 昨日数据需调用专门的统计接口，若不可用则为 null
    fansNumYesterday: z.number().nullable(), // 昨日净增关注
    playNumYesterday: z.number().nullable(), // 昨日新增播放
    likeNumYesterday: z.number().nullable(), // 昨日新增喜欢
    commentNumYesterday: z.number().nullable(), // 昨日新增评论
});

export type shipinhaoConfigData = z.infer<typeof shipinhaoConfigDataSchema>;

export interface SearchAccountInfoResponse {
    code: number;
    message: string;
    data: ttConfigData | xhsConfigData | wxConfigData | bjhConfigData | douyinConfigData | shipinhaoConfigData | null;
}
